import { useApi } from '../useApi'
// eslint-disable-next-line import/no-unresolved
import { getCoreStoresLanguages } from 'data-api'

export const useStoreLanguages = ({ store, options } = {}) => {
	const {
		data = [],
		error,
		isValidating,
		mutate,
		cancel,
		cancelled,
	} = useApi({
		method: getCoreStoresLanguages,
		args: { store },
		paused: !store,
		options,
	})

	data.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))

	return {
		languages: data,
		loading: isValidating,
		error,
		mutate,
		cancel,
		cancelled,
	}
}
